import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './LoginPage.css';

export default function RedefinirSenhaPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase redireciona com token na URL — aguarda sessão ser estabelecida
    supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true);
    });
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('A senha deve ter pelo menos 6 caracteres.'); return; }
    if (password !== confirm) { setError('As senhas não coincidem.'); return; }
    setLoading(true);

    const { error: updateError } = await supabase.auth.updateUser({ password });
    if (updateError) {
      setError('Erro ao redefinir senha: ' + updateError.message);
    } else {
      navigate('/login');
    }
    setLoading(false);
  }

  if (!ready) return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in" style={{ textAlign:'center' }}>
        <div className="spinner" style={{ width:36, height:36, margin:'0 auto 16px' }} />
        <p style={{ color:'var(--text2)' }}>Validando link de redefinição...</p>
      </div>
    </div>
  );

  return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in">
        <div className="login-logo">
          <span className="login-logo-icon">🔐</span>
          <div>
            <h1 className="login-title">Fincasa</h1>
            <p className="login-sub">Nova senha</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Nova Senha</label>
            <input
              type="password"
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Confirmar Nova Senha</label>
            <input
              type="password"
              placeholder="Repita a senha"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <button className="btn btn-primary w-full login-btn" disabled={loading}>
            {loading ? <><span className="spinner" /> Salvando...</> : 'Salvar Nova Senha'}
          </button>
        </form>
      </div>
    </div>
  );
}
